module.exports = {["template-constructor-control-button_edit"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n	<div class="icon noarrow" data-alt="Edit Text" data-alt-pos="left" data-alt-offset="9"></div>\n\n	<div class="panel"></div>\n\n';
}
return __p;
},}